import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { buildingsActions } from '.';
import { BuildingsService } from '../../services/buildings.service';

@Injectable({
  providedIn: 'root',
})
export class BuildingsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private buildingsService: BuildingsService,
  ) {}

  findAllBuildings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(buildingsActions.findAll),
      mergeMap((action) => {
        return this.buildingsService
          .findAll(action.vendorId)
          .pipe(
            map((response) =>
              buildingsActions.findAllSuccess({ buildings: response.data }),
            ),
          );
      }),
    ),
  );
}
